import {
    ChangeDetectorRef,
    ElementRef,
    Component,
    OnDestroy,
    OnInit,
} from "@angular/core";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { Location } from "@angular/common";
import { Subject, forkJoin } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AppService } from "src/app/app.service";
interface Image {
    src: string;
    thumbnail: string;
    alt: string;
}

@Component({
    selector: "app-dw-club",
    templateUrl: "./dw-club.component.html",
    styleUrls: ["./dw-club.component.scss"],
})
export class DwClubComponent implements OnInit, OnDestroy {
    selectedItem: string = "";
    items = [
        { Name: "English Club", Url: "english-club" },
        { Name: "Ycs Club", Url: "ycs-club" },
        { Name: "Sports Club", Url: "sports-club" },
        { Name: "Quiz Math Club", Url: "math-club" },
        { Name: "Science Club", Url: "science-club" },
        { Name: "Art Handwriting Club", Url: "art-handwriting-club" },
        { Name: "Ecology Club", Url: "ecology-club" },
        { Name: "Art Club", Url: "art-club" },
        { Name: "Chess Club", Url: "chess-club" },
        { Name: "Debate Club", Url: "debate-club" },
        { Name: "Knowledge Fiesta Club", Url: "knowledge-fiesta-club" },
        { Name: "Cultural Club", Url: "cultural-club" },
    ];
    english23: Image[] = [
        {
            src: "assets/img/school/clubs/1.jpg",
            thumbnail: "assets/img/school/clubs/1.jpg",
            alt: "Image 01",
        },
        {
            src: "assets/img/school/clubs/2.jpg",
            thumbnail: "assets/img/school/clubs/2.jpg",
            alt: "Image 02",
        },
        {
            src: "assets/img/school/clubs/3.jpg",
            thumbnail: "assets/img/school/clubs/3.jpg",
            alt: "Image 03",
        },
    ];
    english22: Image[] = [
        {
            src: "assets/img/school/clubs/4.jpg",
            thumbnail: "assets/img/school/clubs/4.jpg",
            alt: "Image 01",
        },
        {
            src: "assets/img/school/clubs/5.jpg",
            thumbnail: "assets/img/school/clubs/5.jpg",
            alt: "Image 02",
        },
        {
            src: "assets/img/school/clubs/6.jpg",
            thumbnail: "assets/img/school/clubs/6.jpg",
            alt: "Image 03",
        },
    ];
    imageLoaded = false;
    fetchinData = true;
    ImageAlbums: any;
    GBs: any;
    GBs1: any;
    GBs2: any;
    TeacherInfo: any;
    GBms: any;
    GBms1: any;
    selectedItemName = "";
    showFullContent = false;
    showFullOverview = false;
    showFullWhy = false;
    showFullIns = false;
    showFullBuilding = false;
    showFullCulture = false;
    private ngUnsubscribe = new Subject();
    AboutUs: any;
    mission_data: any;
    vision_data: any;
    news: any;
    why_std: any;
    infus: any;
    histry: any;
    at_a_glance: any;
    oath_data: any;
    achievements: any;
    quiz_data: any;
    it_data: any;
    culture_club_data: any;
    knowledge_club_data: any;
    debate_club_data: any;
    chess_club_data: any;
    art_club_data: any;
    ecology_club_data: any;
    art_handwriting_club_data: any;
    science_club_data: any;
    math_club_data: any;
    sports_club_data: any;
    ycs_club_data: any;
    english_club_data: any;
    showMe: boolean = false;
    activeSection: string | null = null;
    constructor(
        private route: ActivatedRoute,
        private location: Location,
        private appService: AppService,
        private router: Router,
        private _changeDetectorRef: ChangeDetectorRef
    ) {}
    ngOnInit() {
        this.route.paramMap.subscribe((params: ParamMap) => {
            const item = params.get("item");
            const matchedItem = this.items.find((i) => i.Url === item);
            if (item && matchedItem && item == matchedItem.Url) {
                this.selectedItem = item;
                this.selectedItemName = matchedItem.Name;
            } else {
                this.selectedItem = this.items[0].Url;
                this.selectedItemName = this.items[0].Name;
                this.location.replaceState(`/${this.selectedItem}`);
            }
            this.FetchData();
        });
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next(null);
        this.ngUnsubscribe.complete();
    }
    toggleMe(section: string) {
        this.activeSection = this.activeSection === section ? null : section;
    }
    FetchData() {
        this._changeDetectorRef.markForCheck();
        this.fetchinData = true;
        if (
            this.selectedItem === "cultural-club" ||
            this.selectedItem === "knowledge-fiesta-club" ||
            this.selectedItem === "debate-club" ||
            this.selectedItem === "chess-club" ||
            this.selectedItem === "art-club" ||
            this.selectedItem === "ecology-club" ||
            this.selectedItem === "art-handwriting-club" ||
            this.selectedItem === "science-club" ||
            this.selectedItem === "math-club" ||
            this.selectedItem === "sports-club" ||
            this.selectedItem === "ycs-club" ||
            this.selectedItem === "english-club"
        ) {
            this.About_data();
        }
    }

    About_data() {
        forkJoin([this.appService.getContents()])
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((response: any) => {
                console.log(response, "All Response For About Us");

                this.AboutUs = response[0].data;

                if (this.AboutUs != null) {
                    // Culture club
                    let culture = this.AboutUs.filter(
                        (x) => x.ContentCategoryName == "Cultural Club"
                    );
                    this.culture_club_data = culture[0];
                    console.log(this.culture_club_data, "Culture Club Data");
                    // knowledge-fiesta-club
                    let knowledge_data = this.AboutUs.filter(
                        (x) => x.ContentCategoryName == "Knowledge Fiesta Club"
                    );
                    this.knowledge_club_data = knowledge_data[0];
                    console.log(
                        this.knowledge_club_data,
                        "knowledge_club_data"
                    );
                    // debate-club
                    let debate_club = this.AboutUs.filter(
                        (x) => x.ContentCategoryName == "Debate Club"
                    );
                    this.debate_club_data = debate_club[0];
                    console.log(this.debate_club_data, "debate_club_data");
                    // chess - club;
                    let chess_club = this.AboutUs.filter(
                        (x) => x.ContentCategoryName == "Chess Club"
                    );
                    this.chess_club_data = chess_club[0];
                    console.log(this.chess_club_data, "chess_club_data");
                    // Art - club;
                    let art_club = this.AboutUs.filter(
                        (x) => x.ContentCategoryName == "Art Club"
                    );
                    this.art_club_data = art_club[0];
                    console.log(this.art_club_data, "art_club_data");
                    // ecology-club;
                    let ecology_club = this.AboutUs.filter(
                        (x) => x.ContentCategoryName == "Ecology Club"
                    );
                    this.ecology_club_data = ecology_club[0];
                    console.log(this.ecology_club_data, "ecology_club_data");
                    // art_handwriting_club;
                    let art_handwriting_club = this.AboutUs.filter(
                        (x) => x.ContentCategoryName == "Art Handwriting Club"
                    );
                    this.art_handwriting_club_data = art_handwriting_club[0];
                    console.log(
                        this.art_handwriting_club_data,
                        "art_handwriting_club"
                    );
                    // science - club;
                    let science_club = this.AboutUs.filter(
                        (x) => x.ContentCategoryName == "Science Club"
                    );
                    this.science_club_data = science_club[0];
                    console.log(this.science_club_data, "science_club_data");
                    // math-club;
                    let math_club = this.AboutUs.filter(
                        (x) => x.ContentCategoryName == "Math Club"
                    );
                    this.math_club_data = math_club[0];
                    console.log(this.math_club_data, "math_club_data");
                    // Sports club
                    let sports_club = this.AboutUs.filter(
                        (x) => x.ContentCategoryName == "Sports Club"
                    );
                    this.sports_club_data = sports_club[0];
                    console.log(this.sports_club_data, "sports_club_data");
                    // Ycs club
                    let ycs_club = this.AboutUs.filter(
                        (x) => x.ContentCategoryName == "Ycs Club"
                    );
                    this.ycs_club_data = ycs_club[0];
                    console.log(this.ycs_club_data, "ycs_club_data");
                    // English club
                    let english_club = this.AboutUs.filter(
                        (x) => x.ContentCategoryName == "English Language Club"
                    );
                    this.english_club_data = english_club[0];
                    console.log(this.english_club_data, "English_club_data");
                }

                this.fetchinData = false;
            });
    }
    selectItem(item: string) {
        this.selectedItem = item;
        const matchedItem = this.items.find((i) => i.Url === item);
        this.selectedItemName = matchedItem.Name;
        if (this.selectedItem === "english-club") {
            this.location.go(`/clubs/${item}`);
        } else if (this.selectedItem === "ycs-club") {
            this.location.go(`/clubs/${item}`);
        } else if (this.selectedItem === "sports-club") {
            this.location.go(`/clubs/${item}`);
        } else if (this.selectedItem === "math-club") {
            this.location.go(`/clubs/${item}`);
        } else if (this.selectedItem === "science-club") {
            this.location.go(`/clubs/${item}`);
        } else if (this.selectedItem === "art-handwriting-club") {
            this.location.go(`/clubs/${item}`);
        } else if (this.selectedItem === "ecology-club") {
            this.location.go(`/clubs/${item}`);
        } else if (this.selectedItem === "art-club") {
            this.location.go(`/clubs/${item}`);
        } else if (this.selectedItem === "chess-club") {
            this.location.go(`/clubs/${item}`);
        } else if (this.selectedItem === "debate-club") {
            this.location.go(`/clubs/${item}`);
        } else if (this.selectedItem === "knowledge-fiesta-club") {
            this.location.go(`/clubs/${item}`);
        } else if (this.selectedItem === "cultural-club") {
            this.location.go(`/clubs/${item}`);
        } else {
            this.location.go(`/clubs/quiz-club`);
        }
    }
    TransformUrl(value) {
        if (value.includes("https://")) {
            return value;
        } else {
            return `https://${value}`;
        }
    }
}
